import { gql } from "@apollo/client";

// Calculated: Apr-end + May-incoming - May-outgoing, keyed by materialEntityRelation.code
const MAY_END_INVENTORY = {
  "20236371": 20000,
  "21103458": 380000,
  "21108585": 0,
  "21108595": 0,
  "21113480": 0,
  "21121971": 0,
  "21295786": 0,
  "21504072": 0,
  "60402313": 0,
  "60614697": 85000,
  "60614857": 0,
  "60622032": 0,
  "60622641": 48000,
  "60630893": 100000,
  "60630896": 90000,
  "60645083": 243000,
  "60645119": 6000,
  "60645167": 0,
  "60645178": 6000,
  "90217676": 194000,
  "90279693": 0,
  "90281520": 0,
  "90346781": 21000,
  "90347431": 0,
  "90498368": 0,
  "90622860": -138000,
  "90623373": 100844,
  "90760402": 10500,
  "90760540": 0,
  "90770855": 0,
  "90770980": 15000,
  "90772944": 39000,
  "90805311": 10000,
  "91093169": -124000,
  "91191151": 0,
  "91202832": 0,
  "91219116": 0,
  "91219146": 0,
  "91240748": 54000,
  "91288165": 0,
  "91394961": 0,
  "91471749": 0,
  "91758065": 15000,
  "91763121": 3000,
  "91763865": 136804,
  "91766203": -904000,
  "91771132": 198500,
  "91824418": 0,
  "91828301": 150000,
  "96539941": 460000,
  "96547031": 100000,
  "97451997": 240000,
  "97553575": 0,
  "98796347": 0,
  "98859830": 432000,
  "98913027": 0,
  "99251889": 6000,
  "99283654": 11000,
  "99328100": 280000,
  "99371711": -28000,
  "99435576": 20000,
  "99659812": 165000,
  "99748948": 0,
  "99883383": -900000,
};

const UPDATE_MATERIAL = gql`
  mutation UpdateMaterial($input: UpdateMaterialInput!) {
    updateMaterial(input: $input) {
      id
      inventory
    }
  }
`;

export default async function batchUpdateInventoryMay2026({ rows, client }) {
  const updates = [];
  const notFound = [];
  const negative = [];

  for (const row of rows) {
    const relations = row.materialEntityRelations?.items || [];
    const matchedCode = relations.find(
      (r) => MAY_END_INVENTORY[r.code] !== undefined
    );

    if (!matchedCode) continue;

    const newInventory = MAY_END_INVENTORY[matchedCode.code];

    if (newInventory < 0) {
      negative.push({ id: row.id, mfr: row.mfr, mpn: row.mpn, code: matchedCode.code, value: newInventory });
    }

    updates.push({ id: row.id, mfr: row.mfr, mpn: row.mpn, code: matchedCode.code, inventory: newInventory });
  }

  // Codes in the inventory table with no matching material in DB
  const foundCodes = new Set(updates.map((u) => u.code));
  for (const code of Object.keys(MAY_END_INVENTORY)) {
    if (!foundCodes.has(code)) notFound.push(code);
  }

  if (negative.length > 0) {
    const msg = negative
      .map((n) => `  ${n.code} (${n.mfr} ${n.mpn}): ${n.value}`)
      .join("\n");
    const proceed = window.confirm(
      `⚠️ 以下 ${negative.length} 个料号计算出负库存，可能是数据缺失，确认继续更新？\n\n${msg}`
    );
    if (!proceed) return { cancelled: true };
  }

  const confirmed = window.confirm(
    `即将更新 ${updates.length} 个料号的5月底库存。${
      notFound.length > 0
        ? `\n\n以下 ${notFound.length} 个Code在数据库中未找到对应料号（将跳过）：\n${notFound.join(", ")}`
        : ""
    }\n\n确认执行？`
  );

  if (!confirmed) return { cancelled: true };

  let succeeded = 0;
  let failed = 0;
  const errors = [];

  for (const u of updates) {
    try {
      await client.mutate({
        mutation: UPDATE_MATERIAL,
        variables: { input: { id: u.id, inventory: u.inventory } },
      });
      succeeded++;
    } catch (err) {
      failed++;
      errors.push({ ...u, error: err.message });
    }
  }

  const summary = `✅ 更新完成：成功 ${succeeded} 条，失败 ${failed} 条${
    errors.length > 0 ? `\n\n失败详情：\n${errors.map((e) => `${e.code} ${e.mpn}: ${e.error}`).join("\n")}` : ""
  }`;

  alert(summary);
  return { succeeded, failed, errors, notFound };
}
